<template>
  <Modal v-model="show" title="任务" :closable="false" :mask-closable="false" width="900px">
    <div v-show="tab === 1">
      <Form v-if="isAuthor" :model="queryForm" inline :label-width="80">
        <FormItem prop="envId" label="环境：">
          <Select v-model="queryForm.envId" clearable style="width: 200px">
            <Option v-for="item in envList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="name" label="任务名称">
          <Input type="text" v-model="queryForm.name" placeholder="请输入任务名称" style="width: 200px" />
        </FormItem>
        <div class="action">
          <Button type="primary" @click="getTaskList('queryForm')">搜索</Button>
          <p v-if="isAuthor" class="selected" @click="switchTab(2)"><Img src="/icon-folder.png" />已选择 {{ newSelectTaskArr.length }}</p>
        </div>
      </Form>
      <Table
        ref="selection"
        :columns="isAuthor ? authorColumns : columns"
        :data="taskList"
        @on-select="onSelect"
        @on-select-all="onSelectAll"
        @on-select-cancel="onSelectCancel"
        @on-select-all-cancel="onSelectAllCancel"
        :max-height="400"
      >
        <template slot="difficulty" slot-scope="{ row }">
          <div class="difficulty">
            <div v-for="(item, index) in 5" :key="index">
              <img v-if="item <= row.difficulty" src="/images/star-m.png" />
              <img v-else src="/images/star.png" />
            </div>
          </div>
        </template>
        <template slot="envId" slot-scope="{ row }">
          <div v-for="(items, index) in envList" :key="index">
            <div v-if="row.envId === items.id">{{ items.name }}</div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button type="primary" @click="$router.push({ name: 'task-detail', params: { id: row.id } })">进入</Button>
        </template>
      </Table>
      <Page :total="total" @on-change="pageChange" show-total v-if="isAuthor && total > queryForm.limit" />
    </div>
    <div v-show="tab === 2">
      <p class="mb-20" style="font-size: 16px;color: #1C2A34;">
        <span
          @click="
            tab = 1
            getTaskList()
          "
        >
          <Img src="/icon-back.png" class="mr-10 cursor-pointer" style="width: 24px;" />
        </span>
        已选择 {{ newSelectTaskArr.length }}
      </p>
      <Table ref="selection" :columns="authorColumns" :data="newSelectedTaskArr" @on-selection-change="selectionChange" :max-height="400">
        <template slot="difficulty" slot-scope="{ row }">
          <div class="difficulty">
            <div v-for="(item, index) in 5" :key="index">
              <img v-if="item <= row.difficulty" src="/images/star-m.png" />
              <img v-else src="/images/star.png" />
            </div>
          </div>
        </template>
        <template slot="envId" slot-scope="{ row }">
          <div v-for="(items, index) in envList" :key="index">
            <div v-if="row.envId === items.id">{{ items.name }}</div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button type="primary" @click="$router.push({ name: 'task-detail', params: { id: row.id } })">进入</Button>
        </template>
      </Table>
    </div>
    <template #footer>
      <Button type="default" @click="show = false">{{ isAuthor ? '取消' : '关闭' }}</Button>
      <Button v-if="isAuthor" type="primary" @click="handleSubmit" :loading="loading">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { Modal, Button, Form, FormItem, Select, Option, Input, Table, Page, Message } from 'view-design'
export default {
  components: {
    Modal,
    Button,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    Table,
    Page
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    progress_id: {
      type: Number,
      required: true
    },
    selectTaskArr: {
      type: Array,
      required: true
    },
    // 是否创建者
    isAuthor: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      envList: [],
      authorColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          key: 'id',
          title: '任务码'
        },
        {
          key: 'name',
          title: '任务名称'
        },
        {
          slot: 'difficulty',
          title: '难度'
        },
        {
          slot: 'envId',
          title: '环境'
        }
      ],
      columns: [
        {
          key: 'id',
          title: '任务码'
        },
        {
          key: 'name',
          title: '任务名称'
        },
        {
          slot: 'difficulty',
          title: '难度'
        },
        {
          slot: 'envId',
          title: '环境'
        },
        {
          slot: 'action',
          title: '操作'
        }
      ],
      queryForm: {
        limit: 10,
        page: 1,
        name: '',
        envId: undefined
      },
      taskList: [],
      total: 0,
      newSelectTaskArr: [],
      newSelectedTaskArr: [], // 已选择的列表，只用做table表格
      tab: 1 // 1-默认表格，2-以选择表格
    }
  },
  created() {
    this.getEnvList()
    // this.getAllTask()
  },
  methods: {
    async getEnvList() {
      const res = await this.$store.dispatch('getEnvList')
      this.envList = res
    },
    async getTaskList() {
      const params = {
        uriCode: 'ZP_API0011',
        ...this.queryForm
      }
      const res = await this.$fetch(params)
      res.list = res.list.map(item => {
        let _checked = false
        if (this.newSelectTaskArr.find(item2 => item2.id === item.id)) {
          _checked = true
        }
        return {
          ...item,
          _checked
        }
      })
      this.taskList = res.list
      this.total = res.total_record
    },
    pageChange(page) {
      this.queryForm.page = page
      this.getTaskList()
    },
    // 单项选中
    onSelect(selection, row) {
      this.newSelectTaskArr.push(row)
      this.newSelectTaskArr = this.newSelectTaskArr.map(item => {
        return {
          ...item,
          _checked: true
        }
      })
    },
    // 全部选中
    onSelectAll(selection) {
      const arr = [...this.newSelectTaskArr, ...selection]
      // 去重
      let newArr = []
      arr.forEach(item => {
        const obj = newArr.find(item2 => {
          return item2.id === item.id
        })
        if (!obj) {
          newArr.push(item)
        }
      })
      this.newSelectTaskArr = newArr.map(item => {
        return {
          ...item,
          _checked: true
        }
      })
    },
    // 单项取消选中
    onSelectCancel(selection, row) {
      this.newSelectTaskArr = this.newSelectTaskArr.filter(item => item.id !== row.id)
    },
    // 全部取消选中
    onSelectAllCancel() {
      this.newSelectTaskArr = this.newSelectTaskArr.filter(item => {
        const obj = this.taskList.find(item2 => item2.id === item.id)
        return !obj
      })
    },
    // 以选择的table列表里面
    selectionChange(section) {
      this.newSelectTaskArr = section
    },
    async handleSubmit() {
      // if (this.newSelectTaskArr.length < 0) {
      //   Message.error('请选择任务！')
      //   return
      // }
      const params = {
        uriCode: 'ZP_API007',
        progress_id: this.progress_id,
        task_id: this.newSelectTaskArr.map(item => item.id)
      }
      try {
        this.loading = true
        await this.$fetch(params)
        Message.success('关联任务成功')
        this.show = false
        this.$emit('ok')
      } finally {
        this.loading = false
      }
    },
    // 获取所有任务
    async getAllTask() {
      const params = {
        uriCode: 'API007',
        limit: 10000,
        page: 1
      }
      await this.$fetch(params)
    },
    switchTab() {
      this.newSelectedTaskArr = JSON.parse(JSON.stringify(this.newSelectTaskArr))
      this.tab = 2
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 创建者
        if (this.isAuthor) {
          this.newSelectTaskArr = this.selectTaskArr.map(item => {
            return {
              ...item,
              _checked: true
            }
          })
          this.getTaskList()
        } else {
          // 成员
          this.taskList = this.selectTaskArr
        }
      } else {
        Object.assign(this.$data, this.$options.data())
      }
    }
  }
}
</script>
<style lang="scss" scoped>
form {
  border-bottom: 1px solid rgba(28, 42, 52, 0.1);
  padding-bottom: 16px;
  margin-bottom: 24px;
  .ivu-form-item {
    margin-bottom: 0;
  }
}
.action {
  display: inline-block;
  button {
    float: left;
    margin-right: 24px;
  }
  .selected {
    display: flex;
    margin-left: 24px;
    color: #1890ff;
    align-items: center;
    margin-top: 3px;
    cursor: pointer;
    img {
      width: 24px;
      margin-right: 8px;
    }
  }
}
.ivu-page {
  margin-top: 24px;
  text-align: right;
}
.difficulty {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  img {
    widows: 16px;
    height: 16px;
    margin-right: 5px;
  }
}
</style>
